import { NavLink, useLocation } from "react-router-dom";
import { Briefcase, Wallet, Gift, UserCircle } from "lucide-react";

const ITEMS = [
    { to: "/pro", label: "Jobs", icon: Briefcase, testid: "pro-nav-jobs", exact: true },
    { to: "/pro/earnings", label: "Earnings", icon: Wallet, testid: "pro-nav-earnings" },
    { to: "/pro/referral", label: "Referral", icon: Gift, testid: "pro-nav-referral" },
    { to: "/pro/account", label: "Account", icon: UserCircle, testid: "pro-nav-account" },
];

export function ProShell({ children }) {
    const loc = useLocation();
    return (
        <div className="mx-auto min-h-screen max-w-md bg-lightbg">
            <div className="pb-24">{children}</div>
            <nav className="fixed bottom-0 left-0 right-0 z-40 mx-auto max-w-md border-t border-navy/10 bg-white px-2 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(16,42,67,0.06)]">
                <div className="flex items-stretch justify-around">
                    {ITEMS.map((it) => {
                        const active = it.exact ? loc.pathname === it.to : loc.pathname.startsWith(it.to);
                        const Icon = it.icon;
                        return (
                            <NavLink key={it.to} to={it.to} data-testid={it.testid} className="flex flex-1 flex-col items-center gap-1 py-2.5 transition-colors">
                                <Icon size={22} strokeWidth={active ? 2.4 : 1.8} className={active ? "text-orange" : "text-navy/50"} />
                                <span className={`text-[11px] font-semibold ${active ? "text-navy" : "text-navy/50"}`}>{it.label}</span>
                            </NavLink>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
}
